<template>
    <div>
        <app-bar :actionBtns="{ visible: isImportSuccess ? true : false }" :backBtn="{ visible: true }">
            <template v-if="classification == 'PRIMARY'" #title>Add Merchant</template>
            <template v-else #title>Add Branch</template>
            <template v-slot:actionBtns v-if="isImportSuccess">
                <v-btn color="black" class="mx-1" outlined text @click="reset = true">Import Another File</v-btn>
            </template>
        </app-bar>
        <ImportForm :classification="classification" :isImportSuccess="isImportSuccess" :reset="reset" />
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import ImportForm from '@/components/Merchant/ImportForm.vue';

export default {
    name: 'AddImport',
    components: {
        AppBar,
        ImportForm
    },
    data() {
        return {
            reset: false
        };
    },
    computed: {
        classification() {
            if (this.$route.path.indexOf('merchants') > -1 && this.$route.path.indexOf('branches') > -1) {
                return 'BRANCH';
            }
            return 'PRIMARY';
        },
        isImportSuccess() {
            return this.$store.getters['merchants/getIsImportSuccess'];
        }
    }
};
</script>
